import { OsView } from "@/admin/metal/os/OsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/metal/os")({
    component: OsView,
});
